// Add 'restyle' class to body if URL contains 'restyle' (immediate execution)
(function() {
  const currentPath = window.location.pathname;
  
  if (currentPath.includes('restyle')) {
    document.body.classList.add('restyle');
  }
})();

// // Custom Megamenu for Shop (works without child items)
// document.addEventListener('DOMContentLoaded', function() {
//   // Try to find Shop link in different structures
//   let shopElement = document.querySelector('[menu-title="Shop"]');
  
//   // If not found, try alternative selectors
//   if (!shopElement) {
//     shopElement = document.querySelector('.header__item--shop');
//   }
  
//   if (!shopElement) {
//     // Look for any link containing "Shop"
//     const allLinks = document.querySelectorAll('.header__item');
//     shopElement = Array.from(allLinks).find(link => 
//       link.textContent.trim().toLowerCase() === 'shop'
//     );
//   }
  
//   if (shopElement) {
//     // Get the parent container
//     const shopParent = shopElement.closest('.header__nav') || shopElement.parentElement;
    
//     // Create wrapper if Shop is a simple link
//     if (!shopElement.closest('.header__dropdown-toggle')) {
//       const wrapper = document.createElement('div');
//       wrapper.className = 'header__dropdown-toggle custom-shop-wrapper';
//       wrapper.style.position = 'relative';
      
//       shopElement.parentNode.insertBefore(wrapper, shopElement);
//       wrapper.appendChild(shopElement);
      
//       // Prevent default link behavior on hover
//       shopElement.addEventListener('click', function(e) {
//         e.preventDefault();
//         // Optional: navigate to shop page on click
//         // window.location.href = this.href;
//       });
//     }
    
//     const container = shopElement.closest('.header__dropdown-toggle') || 
//                      shopElement.closest('.custom-shop-wrapper');
    
//     // Create the custom megamenu HTML
//     const megamenuHTML = `
//       <div class="custom-megamenu" id="customShopMegamenu">
//         <div class="megamenu-grid">
//           <div class="megamenu-column">
//             <h3>Hair</h3>
//             <div class="megamenu-links">
//               <a href="/collections/hair-shampoo">Hair Shampoo</a>
//               <a href="/collections/hair-conditioner">Hair Conditioner</a>
//               <a href="/collections/hair-mask">Hair Mask</a>
//               <a href="/collections/hair-serum">Hair Serum</a>
//             </div>
//           </div>
//           <div class="megamenu-column">
//             <div class="megamenu-links" style="margin-top: 3rem;">
//               <a href="/collections/hair-styling">Hair Styling</a>
//               <a href="/collections/hair-electronics">Hair Electronics</a>
//               <a href="/collections/all">Shop All Products</a>
//             </div>
//           </div>
//         </div>
//       </div>
//     `;
    
//     // Insert the megamenu
//     container.insertAdjacentHTML('afterend', megamenuHTML);
    
//     const customMegamenu = document.getElementById('customShopMegamenu');
//     let hoverTimeout;
    
//     // Show megamenu on hover
//     container.addEventListener('mouseenter', function() {
//       clearTimeout(hoverTimeout);
//       customMegamenu.classList.add('active');
//     });
    
//     // Hide megamenu functions
//     function hideMegamenu() {
//       hoverTimeout = setTimeout(() => {
//         customMegamenu.classList.remove('active');
//       }, 150);
//     }
    
//     container.addEventListener('mouseleave', hideMegamenu);
//     customMegamenu.addEventListener('mouseleave', hideMegamenu);
//     customMegamenu.addEventListener('mouseenter', function() {
//       clearTimeout(hoverTimeout);
//     });
//   }
// });
